import { render, staticRenderFns } from "./AddPhotoBtn.vue?vue&type=template&id=37893485&scoped=true&"
import script from "./AddPhotoBtn.vue?vue&type=script&lang=js&"
export * from "./AddPhotoBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotoBtn.vue?vue&type=style&index=0&id=37893485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37893485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37893485')) {
      api.createRecord('37893485', component.options)
    } else {
      api.reload('37893485', component.options)
    }
    module.hot.accept("./AddPhotoBtn.vue?vue&type=template&id=37893485&scoped=true&", function () {
      api.rerender('37893485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/AddPhotoBtn.vue"
export default component.exports